import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  readActiveAgreements,
  saveAgreementConsent,
  readAgreements,
  saveAgreement,
  updateAgreement,
  deleteAgreement,
  readConsentAnalytics,
  readConsentUsers,
  readConsentEntityAnalytics,
  readConsentEntityDetails,
} from "./agreementsApi";
import {
  readActiveAgreementsSuccess,
  readActiveAgreementsFailure,
  saveConsentSuccess,
  saveConsentFailure,
  readAgreementsSuccess,
  readAgreementsFailure,
  saveAgreementSuccess,
  saveAgreementFailure,
  updateAgreementSuccess,
  updateAgreementFailure,
  deleteAgreementSuccess,
  deleteAgreementFailure,
  readConsentAnalyticsSuccess,
  readConsentAnalyticsFailure,
  readConsentUsersSuccess,
  readConsentUsersFailure,
  readConsentEntityAnalyticsSuccess,
  readConsentEntityAnalyticsFailure,
  readConsentEntityDetailsSuccess,
  readConsentEntityDetailsFailure,
} from "./agreementsActions";

function* readActiveAgreementsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readActiveAgreements, apiPayloadRequest || {});
    const items = data?.data || data || [];
    yield put(readActiveAgreementsSuccess(items));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: items });
    }
  } catch (error) {
    yield put(readActiveAgreementsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* saveConsentSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(saveAgreementConsent, apiPayloadRequest || {});
    yield put(saveConsentSuccess(data?.data || data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: data?.data || data });
    }
  } catch (error) {
    yield put(saveConsentFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readAgreementsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readAgreements, apiPayloadRequest || {});
    const items = data?.data || data || [];
    yield put(readAgreementsSuccess(items));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: items });
    }
  } catch (error) {
    yield put(readAgreementsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* saveAgreementSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(saveAgreement, apiPayloadRequest || {});
    const saved = data?.data?.[0] || data?.data || apiPayloadRequest;
    yield put(saveAgreementSuccess(saved));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: saved });
    }
  } catch (error) {
    yield put(saveAgreementFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* updateAgreementSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(updateAgreement, apiPayloadRequest || {});
    const updated = data?.data?.[0] || data?.data || apiPayloadRequest;
    yield put(updateAgreementSuccess(updated));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: updated });
    }
  } catch (error) {
    yield put(updateAgreementFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* deleteAgreementSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(deleteAgreement, apiPayloadRequest || {});
    if (data?.type === 1 || data?.data || data?.message) {
      yield put(deleteAgreementSuccess(apiPayloadRequest));
      if (typeof action.callback === "function") {
        action.callback({ type: 1, data: apiPayloadRequest });
      }
    } else {
      const errorMsg = data?.message || "Delete failed";
      yield put(deleteAgreementFailure(errorMsg));
      if (typeof action.callback === "function") {
        action.callback({ type: 0, error: errorMsg });
      }
    }
  } catch (error) {
    yield put(deleteAgreementFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readConsentAnalyticsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readConsentAnalytics, apiPayloadRequest || {});
    yield put(readConsentAnalyticsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readConsentAnalyticsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readConsentUsersSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readConsentUsers, apiPayloadRequest || {});
    yield put(readConsentUsersSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readConsentUsersFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readConsentEntityAnalyticsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readConsentEntityAnalytics, apiPayloadRequest || {});
    yield put(readConsentEntityAnalyticsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readConsentEntityAnalyticsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readConsentEntityDetailsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readConsentEntityDetails, apiPayloadRequest || {});
    yield put(readConsentEntityDetailsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readConsentEntityDetailsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

export default function* agreementsWatcherSaga() {
  yield takeLatest(actionTypes.READ_ACTIVE_AGREEMENTS_REQUEST, readActiveAgreementsSaga);
  yield takeLatest(actionTypes.SAVE_CONSENT_REQUEST, saveConsentSaga);
  yield takeLatest(actionTypes.READ_AGREEMENTS_REQUEST, readAgreementsSaga);
  yield takeLatest(actionTypes.SAVE_AGREEMENT_REQUEST, saveAgreementSaga);
  yield takeLatest(actionTypes.UPDATE_AGREEMENT_REQUEST, updateAgreementSaga);
  yield takeLatest(actionTypes.DELETE_AGREEMENT_REQUEST, deleteAgreementSaga);
  yield takeLatest(actionTypes.READ_CONSENT_ANALYTICS_REQUEST, readConsentAnalyticsSaga);
  yield takeLatest(actionTypes.READ_CONSENT_USERS_REQUEST, readConsentUsersSaga);
  yield takeLatest(
    actionTypes.READ_CONSENT_ENTITY_ANALYTICS_REQUEST,
    readConsentEntityAnalyticsSaga
  );
  yield takeEvery(
    actionTypes.READ_CONSENT_ENTITY_DETAILS_REQUEST,
    readConsentEntityDetailsSaga
  );
}
